import { Product, Variant } from "../../../types/types";

export function getUniqueColours(product: Product): Variant[] {
  const variants = getVariantsWithColours(product.variants);

  return variants.filter(
    (value, index, self) =>
      self.findIndex(
        (v) => v.differentiators?.colour === value.differentiators?.colour,
      ) === index,
  );
}

export function getVariantsWithColours(variants: Variant[]) {
  return variants.filter((variant) => Boolean(variant.differentiators?.colour));
}
